import React from 'react'
import { Route } from 'react-router-dom'
import { auth } from '../../../services/util/auth.service'
import CadastroInsumo from './CadastroInsumo/CadastroInsumo'
import InsumoMenu from './InsumoMenu/InsumoMenu'
import EntradaSaidaInsumo from './EntradaSaidaInsumo/EntradaSaidaInsumo'
import PainelInsumo from './PainelInsumo/PainelInsumo'

export default function Insumo() {
  return (
    <>
      <Route path="/main/insumo/menu" render={() => auth(<InsumoMenu />)} />
      <Route path="/main/insumo/cadastro-insumo" render={() => auth(<CadastroInsumo />, 107)} />
      <Route
        path="/main/insumo/entrada-saida-insumo"
        render={() => auth(<EntradaSaidaInsumo />, 108)}
      />
      <Route path="/main/insumo/painel-insumo" render={() => auth(<PainelInsumo />, 109)} />
    </>
  )
}
